export const api = (process.env.NODE_ENV === "production") ? "https://api.vilmarturnes.com.br" : "http://localhost:8000"